export default __webpack_public_path__ + "static/media/Conversation_about_reusable_and_plastic_dishes_BHS.6238a5e6.mp4";